export default {"src":"/_next/static/media/phone.9e84736d.svg","height":24,"width":24};